import { createIsland } from '../../../utils/island';

export class RightSidebarView {
  readonly body = createIsland();
  readonly header = createIsland();
}
